<template>
  <iRow width="hug">
    <iTextEditInput
      v-model="localEmail"
      label="Email"
      :min-width="400"
      :disabled="editMode"
      editable-on-click
      @submit="submit"
    />
  </iRow>
</template>

<script>
// `~/stores/user-store` lives outside the editor directory tree. The
// real email change flow (with confirmation step) runs on the FanWeb
// side. Canvas preview shows the simple editable email field.
import { UserSettingsPageElementMixin } from "%/dynamic-component-editor/standard-pages/user-settings-page/user-settings-page-element-mixin";

export default {
  name: "ChangeEmail",
  mixins: [UserSettingsPageElementMixin],
  elementPanelSettings: {
    displayName: "Change Email Field",
    displayIcon: "document",
    elementGroup: "userSettingsElements",
    elementType: "element",
  },
  data() {
    return {
      localEmail: "user@example.com",
    };
  },
  methods: {
    submit() {
      // No-op in Studio canvas preview.
    },
  },
};
</script>
